// ── IMAGE SLOTS (Church Team Ready) ────────────────────────────────
// Hosted in the Impultienda store resources and ebook covers.
const STORE = '39a0ec39-fc81-46a5-af7f-356dcfd8e037';
const RES = `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/${STORE}/`;
const COVER = (id: string) =>
  `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/render/image/public/ebook-images/${STORE}/${id}-mockup.webp?width=720&quality=85&resize=contain`;

/**
 * iMac + 3 tablets + 2 phones, one bonus per device. Composited in code from the real images (no AI text):
 * the Gamma Studio cover plus real pages 4 and 8 on the iMac, and the Impultienda bonus photos with their
 * titles typed in. Pure white background: show it on bg-white.
 */
const IMAC = RES + '1792615939706_church-mockup-imac-6b91c06a.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/** Real pages of the Gamma Studio book (9:16), same order as lookInside.captions: p.4, 8, 9, 10, 38, 39. */
export const pageImages: string[] = [
  RES + '1792615946222_church-pagina-04-plan-q1-ef0c805b.webp',
  RES + '1792615950667_church-pagina-08-training-01-plan-6339f3ad.webp',
  RES + '1792615955120_church-pagina-09-training-01-lead-7549b559.webp',
  RES + '1792615959214_church-pagina-10-training-01-sunday-e81fed98.webp',
  RES + '1792615965974_church-pagina-38-sunday-hard-ed2a6b5c.webp',
  RES + '1792616015653_church-pagina-39-planner-8727c7e4.webp',
];
/** 5 bonus covers, in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  COVER('438c160a-f336-429a-9e7a-854be5005523'),
  COVER('38d60bc0-e2be-4876-ae5e-91242ed603b5'),
  COVER('0b0f7810-f00a-4dc3-9cd2-ee5627118438'),
  COVER('efceafe1-dc22-4657-a2a1-5e3490cc3f21'),
  COVER('6129d7bc-8e3f-4087-b638-a74938099d3e'),
];
